import * as Types from '../model/types';
import * as OpKinds from '../opKinds';
import * as Graph from '../graph';

const makeArtifactTypeOp = OpKinds.makeStandardOp;

const artifactTypeArgTypes = {
  artifactType: 'artifactType' as const,
};
const artifactTypeArgDescription = `A ${Graph.docType('artifactType')}`;

export const opArtifactTypeName = makeArtifactTypeOp({
  name: 'artifactType-name',
  argTypes: artifactTypeArgTypes,
  description: `Returns the name of the ${Graph.docType('artifactType')}`,
  argDescriptions: {artifactType: artifactTypeArgDescription},
  returnValueDescription: `The name of the ${Graph.docType('artifactType')}`,
  returnType: inputTypes => 'string',
  resolver: ({artifactType}) => artifactType.name,
});

export const opArtifactTypeArtifacts = makeArtifactTypeOp({
  name: 'artifactType-artifacts',
  argTypes: artifactTypeArgTypes,
  description: `Returns the ${Graph.docType('artifact', {
    plural: true,
  })} of the ${Graph.docType('artifactType')}`,
  argDescriptions: {artifactType: artifactTypeArgDescription},
  returnValueDescription: `The ${Graph.docType('artifact', {
    plural: true,
  })} of the ${Graph.docType('artifactType')}`,
  returnType: inputTypes => Types.list('artifact'),
  resolver: ({artifactType}) =>
    artifactType.artifactSequences.edges.map((artifact: any) => artifact.node),
});

export const opArtifactTypeArtifactVersions = makeArtifactTypeOp({
  name: 'artifactType-artifactVersions',
  argTypes: artifactTypeArgTypes,
  description: `Returns the ${Graph.docType('artifactVersion', {
    plural: true,
  })} of all ${Graph.docType('artifact', {
    plural: true,
  })} of the ${Graph.docType('artifactType')}`,
  argDescriptions: {artifactType: artifactTypeArgDescription},
  returnValueDescription: `The ${Graph.docType('artifactVersion', {
    plural: true,
  })} of all ${Graph.docType('artifact', {
    plural: true,
  })} of the ${Graph.docType('artifactType')}`,
  returnType: inputTypes => Types.list('artifactVersion'),
  resolver: ({artifactType}) =>
    artifactType.artifactSequences.edges.flatMap((as: any) =>
      as.node.artifacts.edges.map((artifact: any) => artifact.node)
    ),
});
